export class InitialArticleInfo {

    public frequencies?: string[];
    public invoicingModes?: string[];
    public numberOfChanges?: string[];
    public contractDuration?: string;
    public quantityMin?: string;
    public quantityMax?: string;

}
